import React, { useCallback, useState } from 'react';
import Modal from 'react-modal';
import './css/FindCommanderModal.css';

const FindCommanderModal = ({ isOpen, onRequestClose, onSearch, onNavigate }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSearch = useCallback(async () => {
    const normalizedQuery = String(query || '').trim();
    if (normalizedQuery.length < 2) {
      setErrorMessage('Please enter at least 2 characters.');
      setResults([]);
      setHasSearched(false);
      return;
    }

    setIsSearching(true);
    setErrorMessage('');
    setHasSearched(true);

    try {
      const nextResults = await onSearch(normalizedQuery);
      setResults(Array.isArray(nextResults) ? nextResults : []);
    } catch (error) {
      setResults([]);
      setErrorMessage(error?.message || 'Failed to search map locations.');
    } finally {
      setIsSearching(false);
    }
  }, [onSearch, query]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSearch();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="find-commander-modal"
      overlayClassName="find-commander-modal-overlay"
    >
      <h2 className="find-commander-modal-title">Find Commander on Map</h2>

      <div className="find-commander-search-row">
        <input
          type="text"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={handleKeyDown}
          className="find-commander-input"
          placeholder="Enter commander name"
        />
        <button
          type="button"
          onClick={handleSearch}
          className="find-commander-button"
          disabled={isSearching}
        >
          {isSearching ? 'Searching...' : 'Search'}
        </button>
      </div>

      {errorMessage && (
        <p className="find-commander-error">{errorMessage}</p>
      )}

      <div className="find-commander-results">
        {hasSearched && !isSearching && !results.length && !errorMessage && (
          <p className="find-commander-empty">No placed commander cities matched this search.</p>
        )}

        {results.map((result) => {
          const resultKey = `${result?.commanderId || ''}-${result?.x},${result?.y}`;
          const commanderName = String(result?.commanderName || 'Unknown Commander');
          const allianceAcronym = String(result?.alliance?.acronym || '').trim();
          const coords = `${Number(result?.x)}:${Number(result?.y)}`;
          return (
            <div key={resultKey} className="find-commander-result-row">
              <div className="find-commander-result-meta">
                <div className="find-commander-result-name">
                  {allianceAcronym ? `[${allianceAcronym}] ` : ''}{commanderName}
                </div>
                <div className="find-commander-result-coords">{coords}</div>
              </div>
              <button
                type="button"
                className="find-commander-button"
                onClick={() => onNavigate(result)}
              >
                Navigate to
              </button>
            </div>
          );
        })}
      </div>

      <div className="find-commander-footer">
        <button type="button" onClick={onRequestClose} className="find-commander-button secondary">
          Close
        </button>
      </div>
    </Modal>
  );
};

export default FindCommanderModal;
